'use strict';

export default function LoadingSidebar({}) {
    return <React.Fragment>
        <div className="el-sidebar__item is-loading"></div>
        <div className="el-sidebar__item is-loading"></div>
    </React.Fragment>
}
